<template>
    <div>
        <div class="navContent">
            <div class="nav">
                <div class="menu" v-if="!isLogin">
                    <div class="logo" @click="goHome"></div>
                    <div class="changeIdentity">
                        <change-identity ref="changeIdentity" @update="update"></change-identity>
                        <div class="identityName" style="margin-left: 20px" @click="openIdentity()">{{identityName}}<i class="el-icon-caret-bottom" /></div>
                    </div>
                    <div class="menus">
                        <!-- 题库、论坛为固定入口；其余菜单由当前学科接口决定 -->
                        <div class="menuItem" :class="activeName=='/questions' ? 'active':''" @click="handleSelect('/questions')">题库</div>
                        <div class="menuItem" :class="activeName=='/forum' ? 'active':''" @click="handleSelect('/forum')">论坛</div>
                        <div
                            class="menuItem"
                            v-for="(item, index) in navMenus"
                            :key="(item.category || 'nav') + '-' + index"
                            :class="item.path && (activeName == item.path || (item.path === '/medicalCode' && activeName.indexOf('/medicalCode/') === 0)) ? 'active' : ''"
                            @click="handleSelect(item.path)"
                        >{{ item.title }}</div>
                        <!-- 接口无会员中心，写死入口 -->
                        <div class="menuItem" :class="activeName=='/openMember' ? 'active':''" @click="handleSelect('/openMember')">会员中心</div>
                    </div>
                </div>
                <div class="logon" v-if="!isLogin">
                    <img src="../assets/aiImg.png" class="aiAsk" @click="aiAsk">
                    <div v-if="userInfo['user_id']" style="display: flex;justify-content: flex-start;align-items: center">
                        <el-dropdown>
                            <div class="avatar-wrapper">
                                <img :src="eEUtils.imgUrl+userInfo['avatar']" class="user-avatar">
                                <span>{{userInfo['nickname']}}</span>
                                <i class="el-icon-caret-bottom" />
                            </div>
                            <el-dropdown-menu slot="dropdown" >
                                <el-dropdown-item @click.native="personInfo">
                                    <div class="userInfo">
                                        <img class="userInfoImg" :src="eEUtils.imgUrl+userInfo['avatar']">
                                        <div class="userInfoName">
                                            <div class="userNickName"><span>{{userInfo['nickname']}}</span><img src="../assets/member.png" v-if="userInfo['vip_day']>0"/> </div>
                                            <span class="userSchool" v-if="userInfo['utype']==1">{{userInfo['hospital']}}|{{userInfo['department']}}</span>
                                            <span class="userSchool" v-if="userInfo['utype']==2">{{userInfo['school']}}|{{userInfo['major']}}</span>
                                        </div>
                                    </div>
                                </el-dropdown-item>
                                <el-dropdown-item  divided @click.native="goHome">首页</el-dropdown-item>
                                <el-dropdown-item  @click.native="personInfo">个人中心</el-dropdown-item>
<!--                                <el-dropdown-item  @click.native="points">积分福利</el-dropdown-item>-->
<!--                                <el-dropdown-item  @click.native="partTimeJob">兼职教研</el-dropdown-item>-->
                                <el-dropdown-item  @click.native="openMember">会员中心</el-dropdown-item>
                                <el-dropdown-item divided @click.native="unlogin">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <div class="notice" v-if="userInfo['user_id']" @click="goRouter('/notice')">
                            <el-badge :is-dot="notice ? true : false" class="item">
                                <i class="el-icon-bell"></i>
                            </el-badge>
                        </div>
                    </div>
                    <div style="cursor: pointer" v-else @click="goLogin()">登录/注册</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getIdentityByEndTime, getNotLabelTree, getQuestionNavigation, logout, myMessageRed, setSwitchIdentity} from "@/plugins/api";
import changeIdentity from "@/components/changeIdentity";
import {EventBus} from "@/plugins/EUtils";
import {mapGetters} from "vuex";

export default {
    components:{changeIdentity},
    props:{
        isLogin: {
            type: Boolean,
            default: false
        },
    },
    data(){
        return{
            eEUtils:EUtils,
            timer:null,
            activeName:'/questions',
            identityIds:[],
            identityId:[],
            identity_id:'',
            notice:0,
            navMenus:[], // 接口导航（会员中心写死，不在此列表）
            navMenusRequestId:0,
        }
    },
    watch:{
        identityId:{
            handler(val){
                if(val.length>0){
                    EUtils.setCookie('identityId', JSON.stringify(val),60*60*60*24*30*30)
                    let identity_id = EUtils.deepClone(val)
                    this.identity_id = identity_id[identity_id.length-1];
                    this.onSwitchIdentity(this.identity_id)
                    this.$store.dispatch('app/setIdentityId', this.identity_id)
                    this.getInfo(this.identity_id)
                    this.getNavMenus()
                    EventBus.$emit('identity_id',this.identity_id)
                }else{
                    this.identity_id = ''
                    this.getNavMenus()
                }
            }
        }
    },
    computed: {
        ...mapGetters([
            'userInfo',
            'identityName'
        ])
    },
    methods:{
        handleSelect(key, keyPath){
            if(!key || key==this.activeName) return
            this.activeName = key
            this.goRouter(key)
        },
        // human / autonomous 从 getIdentityByEndTime 抽出；其余导航分类跳转
        resolveNavPath(category){
            const map = {
                human: '/humanDialogue',
                autonomous: '/autonomous',
                daily: '/dailyPractice',
                points: '/points',
                partTime: '/partTimeJob',
                partTimeJob: '/partTimeJob',
                medicalCode: '/medicalCode',
                'medical-code': '/medicalCode',
            }
            return map[category] || ''
        },
        getNavMenus(){
            if (this.isLogin) return
            this.navMenus = []
            const requestId = ++this.navMenusRequestId
            // handlerData 会连续 push 多层 identity，防抖只请求最终末级
            if (this._navMenusTimer) clearTimeout(this._navMenusTimer)
            if (!this.identity_id) return
            this._navMenusTimer = setTimeout(() => {
                this.fetchNavMenus(requestId)
            }, 80)
        },
        fetchNavMenus(requestId){
            if (this.isLogin) return
            if (!this.identity_id) {
                this.navMenus = []
                return
            }
            const reqId = this.identity_id
            const params = { identity_id: reqId }
            Promise.all([
                getIdentityByEndTime(params).catch(() => null),
                getQuestionNavigation(params).catch(() => null),
            ]).then(([identityRes, navRes]) => {
                if (requestId !== this.navMenusRequestId || reqId !== this.identity_id) return
                const menus = []

                // 1) 从末级身份里抽出 human、autonomous（有则展示，title 用接口）
                const identityList = (identityRes && identityRes.data) ? EUtils.deepClone(identityRes.data) : []
                const pinOrder = ['human', 'autonomous']
                pinOrder.forEach(category => {
                    const found = identityList.find(item => item && item.category === category)
                    if (!found) return
                    menus.push({
                        category,
                        title: found.title,
                        path: this.resolveNavPath(category)
                    })
                })

                // 2) navigation 接口菜单
                const list = (navRes && navRes.data) ? EUtils.deepClone(navRes.data) : []
                let squareMerged = false
                list.forEach(item => {
                    if (!item || !item.category) return
                    const category = item.category
                    // 指定隐藏
                    if (category === 'team' || category === 'WxProgram' || category === 'img') return
                    // 题库、论坛是固定入口；human/autonomous 已从身份接口抽出
                    if (category === 'question' || category === 'forum') return
                    if (category === 'human' || category === 'autonomous') return
                    // unit、exam 合成一个「题集」
                    if (category === 'unit' || category === 'exam') {
                        if (squareMerged) return
                        squareMerged = true
                        menus.push({ category: 'unit', title: '题集', path: '/square' })
                        return
                    }
                    // 其余全部漏出
                    menus.push({
                        category,
                        title: item.title,
                        path: this.resolveNavPath(category)
                    })
                })
                this.navMenus = menus
            })
        },
        update(identityId){
            this.navMenus = []
            this.navMenusRequestId += 1
            if (this._navMenusTimer) clearTimeout(this._navMenusTimer)
            this.identityId = identityId
            this.activeName = '/questions'
            if (this.$route.path !== '/questions') this.$router.replace('/questions')
        },
        aiAsk(){
            this.handleSelect('/aiAsk')
        },
        goHome(){
            this.handleSelect('/questions')
        },
        onSwitchIdentity(identity_id){
            setSwitchIdentity({identity_id:identity_id}).then(res=>{})
        },
        openMember(){
            this.handleSelect('/openMember')
        },
        points(){
            this.handleSelect('/points')
        },
        partTimeJob(){
            this.handleSelect('/partTimeJob')
        },
        personInfo(){
            this.$router.replace('/personalCenter')
        },
        unlogin(){
            logout().then((res)=>{
                EUtils.delCookie('Authorization')
                window.location.replace('/login')
            })
        },
        goLogin(){
            window.location.replace('/login')
            EUtils.delCookie('Authorization')
        },
        openIdentity(){
            this.$refs.changeIdentity.open(this.identityId,this.identityIds)
        },
        getIdentity(flag){
            if(!this.isLogin){
                getNotLabelTree().then(res=>{
                    if(res.code == '200'){
                        this.identityIds = EUtils.deepClone(res.data)
                        let identityName = EUtils.getCookie('identityName')
                        var identityId = EUtils.getCookie('identityId')
                        if(flag && identityId && identityName){
                            identityName = decodeURIComponent(identityName)
                            this.identityId = JSON.parse(identityId)
                            this.$store.dispatch('app/setIdentityName', identityName)
                        }else{
                            this.handlerData(this.identityIds)
                        }
                        // getNavMenus 在 identityId watch 里、identity_id 就绪后调用
                    }
                })
            }
        },
        getInfo(identity_id){
            this.$store.dispatch('app/setUserInfo', identity_id)
        },
        handlerData(identityIds){
            this.identityId.push(identityIds[0].identity_id)
            if(identityIds[0].is_last == 1){
                this.$store.dispatch('app/setIdentityName', identityIds[0].title)
            }
            if(identityIds[0].children && identityIds[0].children.length>0){
                this.handlerData(identityIds[0].children)
            }
        },
        onStart(){
            this.getIdentity(1)
        },
        goRouter(path){
            this.$router.push(path)
        },
        getMessageCount(){
            if(!this.isLogin) {
                myMessageRed().then(res => {
                    this.notice = res.data.red;
                })
            }
        }
    },
    mounted() {
        let activeName = window.location.pathname
        this.activeName = activeName.replace('/web','')
        this.onStart();
        this.getMessageCount();
        this.$store.dispatch('app/getOssToken')
    },
    beforeDestroy() {
        if (this._navMenusTimer) clearTimeout(this._navMenusTimer)
        this.navMenusRequestId += 1
    },
}
</script>

<style scoped lang="scss">
::v-deep .el-menu-demo.el-menu.el-menu--horizontal{
    border-bottom: none;
}
::v-deep .el-dropdown-menu__item:first-child{
    background-color: #ecf5ff;
}

::v-deep .userInfo{
    display: flex;
    align-items: center;
    padding: 20px 0px;
    background-color: #ecf5ff;
    .userInfoImg{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
    }
    .userInfoName{
        line-height: 20px;
        .userNickName{
            display: flex;
            align-items: center;
            img{
                width: 13px;
                height: 13px;
                margin-left: 5px;
            }
        }
        .userSchool{
            font-size: 12px;
        }
    }
}
.navContent{
    width: 100%;
    background: #fff;
    height: 79px;
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    justify-content: center;
    align-items: center;
    .nav{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        box-sizing: border-box;
        .logo{
            width: 40px;
            height: 40px;
            background: url("../assets/logo.png") no-repeat center;
            background-size: 100% 100%;
            border-radius: 25px 25px;
            cursor: pointer;
        }
        .menu{
            width: 1040px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 15px;
            color: #434650;
            line-height: 20px;
            .changeIdentity{
                .identityName{
                    border-right: 1px solid #000;
                    font-weight: bold;
                    padding-right: 20px;
                    box-sizing: border-box;
                    cursor: pointer;
                }
            }
            .menus{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                color: #333;
                .menuItem{
                    cursor: pointer;
                    margin-left: 26px;
                    font-size: 16px;
                    position: relative;
                }
                .menuItem:hover{
                    color: #FF7D00;
                }
                .active{
                    font-weight: 500;
                }
                .active:after{
                    position: absolute;
                    bottom: -5px;
                    left: 50%;
                    display: block;
                    width: 12px;
                    height: 3px;
                    background-color: #FF7D00;
                    border-radius: 2px;
                    -webkit-transform: translateX(-50%);
                    transform: translateX(-50%);
                    content: "";
                }
            }
        }
        .logon{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .aiAsk{
                cursor: pointer;
                width: 30px;
                height: 30px;
                margin-right: 10px;
            }
            .notice{
                color: #606266;
                cursor: pointer;
                margin-top: 5px;
                display: inline-block;
                margin-left: 10px;
                font-size: 15px;
            }
            .avatar-wrapper {
                margin-top: 5px;
                position: relative;
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #606266;
                cursor: pointer;
                .user-avatar {
                    cursor: pointer;
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    margin-right: 10px;
                }

                .el-icon-caret-bottom {
                    cursor: pointer;
                    font-size: 12px;
                    margin-left: 5px;
                }
            }
        }
    }
}

</style>
